import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { Welcome } from '../components/Welcome';
import { MarketContext } from '../components/MarketContext';
import { LaunchCTA } from '../components/LaunchCTA';
import { Vision } from '../components/Vision';
import { JoinQuestionnaire } from '../components/JoinQuestionnaire';
import { DomainCTA } from '../components/DomainCTA';
import { Footer } from '../components/Footer';
import { setPageMeta } from '../lib/setPageMeta';
export function Home() {
  useEffect(() => {
    setPageMeta({
      description: 'A bold new platform for adult dance creators and their fans. Concept in progress.'
    });
  }, []);
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-magenta-500/30 selection:text-magenta-100" data-id="element-327">
      <main data-id="element-328">
        <Hero data-id="element-329" />
        <Welcome data-id="element-330" />
        <MarketContext data-id="element-331" />
        <LaunchCTA data-id="element-332" />
        <Vision data-id="element-333" />
        <JoinQuestionnaire data-id="element-334" />
        <DomainCTA data-id="element-335" />
      </main>
      <Footer data-id="element-336" />
    </div>;
}